
import { Component, Vue } from "vue-property-decorator";
import { Toast } from "vant";
import { StoreProductService } from "src/services";
import pageBack from "src/components/page-back";
import vueWaterfallEasy from 'src/utils/vue-waterfall-easy/vueWaterfallEasy';

@Component({
    components:
    {
        pageBack,
        vueWaterfallEasy,
    }
})
 export default class PhysicalPackageList extends Vue
 {
    /**
    * 是否选择城市弹框
    * @private
    * @returns boolean
    */
    private showCity: boolean = false;

    /**
     * 体检套餐列表（按ids查询）
     * @private
     * @returns void
     */
    public physicalPackageList = [];

    /**
     * loading
     */
    private loading: boolean = false;

    /**
     * 当前页码
     */
    private pageIndex: number = 0;

    /**
     * 体检套餐列表（全量查询）
     * @private
     * @returns void
     */
     private products: Array<any> = [];

    /**
     * 查询条件
     * @private
     * @returns void
     */
    private filters: any = {
        key: '',
        cityName: '',
        brandType: '',
        sexLimit: '',
        priceRange: '',
        minPrice: '',
        maxPrice: '',
        marriageStatus: '2',
    };

    /**
     * 服务商品牌下拉列表
     * @private
     * @returns void
     */
    private brandTypeList: Array<any> = [];

    /**
     * 性别下拉列表
     * @private
     * @returns void
     */
    private sexList: Array<any> = [
        { text: '不限', value: '2' },
        { text: '女', value: '0' },
        { text: '男', value: '1' },
    ];

    /**
     * 价格排序
     * @private
     * @returns void
     */
     private priceSort: Number = 0;

    /**
     * 价格排序映射
     * @private
     * @returns void
     */
     private priceSortMap: any = {
        unSort: 0,
        asc: 1,
        des: 2,
     };

    /**
     * 服务商品牌下拉数据映射
     * @private
     */
    private get priceSortClassName()
    {
        let className = '';
        if (this.priceSort) {
            className = this.priceSort === this.priceSortMap.asc ? 'filters-dropdown-item-price asc' : 'filters-dropdown-item-price des';
        }
        else {
            className = 'filters-dropdown-item-price';
        }
        return className;
    };

    /**
     * 价格区间
     * @private
     * @returns void
     */
     private priceRangeList: Array<any> = [
        { text: '不限', id: 0 , minPrice: null, maxPrice: null },
        { text: '300以下', id: 1, minPrice: 0, maxPrice: 300 },
        { text: '300-1000', id: 2, minPrice: 300, maxPrice: 1000 },
        { text: '1000-1500', id: 3, minPrice: 1000, maxPrice: 1500 },
        { text: '1500-3000', id: 4, minPrice: 1500, maxPrice: 3000 },
        { text: '3000以上', id: 5, minPrice: 3000, maxPrice: null },
    ];

    /**
     * 婚姻状况
     * @private
     * @returns void
     */
    private marriageRangeList: Array<any> = [
        { label: '不限', value: 2 },
        { label: '未婚', value: 1 },
        { label: '已婚', value: 0 },
    ];
    
    /**
     * 服务商品牌下拉数据映射
     * @private
     */
    private get brandTypeMap()
    {
        let obj = {};
        this.brandTypeList.forEach(item => {
            obj[item.value] = item.text;
        })
        return obj;
    };

    /**
     * 性别下拉数据映射
     * @private
     */
     private get sexMap()
    {
        let obj = {};
        this.sexList.forEach(item => {
            obj[item.value] = item.text;
        })
        return obj;
    }

    /**
    * 选中位置
    * @private
    * @returns any
    */
    private get currentLocaltion(): any
    {
        if (this.$store.getters.currentLocaltion) {
            this.filters.cityName = this.$store.getters.currentLocaltion;
        }
        else {
            this.filters.cityName = '深圳市';
        }
        return this.$store.getters.currentLocaltion;
    }
    

    /**
     * ids
     * @private
     * @returns Array<number>
     */
     private get ids()
    {
        let ids = [];
        if (localStorage.getItem("physicalPackageList"))
        {
            ids = JSON.parse(localStorage.getItem("physicalPackageList"));
        }
        return this.$route.params && (this.$route.params.ids) || ids;
    }

    /**
     * 主题配置
     * @private
     * @returns any
     */
    private get properties(): any
    {
        return this.$store.state.properties || {};
    }

    /**
     * 组件创建钩子
     */
    protected async created()
    {
        // this.getPhysicalPackageList()
        await this.loadData({});
        this.getStorePackageBrandType();
    }

    private onSearch(val: any) {
        console.log('val', val)
    }

    // 指定挂载节点
    private getContainer() {
        return document.querySelector('.filters');
    }

    /**
     * 获取体检套餐
     * @private
     * @returns void
     */
     private async getPhysicalPackageList(): Promise<void>
    {
        try
        {
            let { content: result } = await StoreProductService.instance.getStoreProduct({ids: this.ids,pageIndex: 1, pageSize: 99999, productType: 0});
            if(result.data)
            {
                this.physicalPackageList = result.data.items || [];
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /**
     * 获取商品数据列表 
     */
    protected async loadData(parameter: any): Promise<any>
    {
        this.loading = true;
        try {
            this.pageIndex++;
            parameter = {
                pageIndex: this.pageIndex,
                pageSize: 10
            };
            let params: any = {
                productType: 0,
                ...this.filters,
                brandTypes: (this.filters.brandType || this.filters.brandType === 0) ? [this.filters.brandType] : [],
                cityName: this.filters.cityName || this.currentLocaltion || '深圳市',
                sortField: this.priceSort === this.priceSortMap.unSort ? null : 'price',
                isDesc: this.priceSort === this.priceSortMap.unSort ? false : (this.priceSort === this.priceSortMap.des ? true : false ),
            };
            let { content: res } = await StoreProductService.instance.getStoreProduct(
                Object.assign({...params}, parameter)
            );

            let productListData = res.data;
            if (res.data.totalPages == 0)
            {
                (this.$refs.waterfall as any).waterfallOver();
            }
            else
            {
                if (res.data.items)
                {
                    this.products = this.products.concat(productListData.items);
                    this.products.forEach(p => p.src = "");
                }

                if (this.pageIndex == res.data.totalPages)
                {
                    setTimeout(() =>
                    {
                        (this.$refs.waterfall as any).waterfallOver();
                    }, 1);
                }
            }

            return res.data;
        } catch (err) {
            Toast(err);
        }
        finally
        {
            this.loading = false;
        }
    }

    /**
     * 搜索
     */
    protected onRefresh(): void
    {
        this.products = [];
        this.physicalPackageList = [];
        this.pageIndex = 0;
        this.loadData({});
    }

    /**
     * 获取品牌
     * @private
     * @returns void
     */
     private async getStorePackageBrandType(): Promise<void>
    {
        try
        {
            let params: any = {
                productType: 0,
                ids: this.ids || [],
                cityName: this.filters.cityName || this.currentLocaltion || '深圳市'
            };
            let { content: result } = await StoreProductService.instance.getStorePackageBrandType({ ...params });
            if(result.data)
            {
                let list = [{ text: '全部', value: null }];
                if (result.data && result.data.length > 0) {
                    result.data.forEach(item => {
                        list.push(
                            {
                                text: item.brandTypeStr,
                                value: item.brandType,
                            }
                        )
                    });
                }
                this.brandTypeList = list;
            }
        }
        catch(err)
        {
            Toast(err);
        }
    }

    /*
    * 显示城市组件弹框
    * @private
    * @returns void
    */
    private onShowCityModel(): void
    {
        this.showCity = true;
    }

    /*
    * 选择城市
    * @private
    * @returns void
    */
    private async onSelectCity(city: string): Promise<void>
    {
        this.filters.cityName = city;
        this.showCity = false;
        this.onRefresh();
        await this.getStorePackageBrandType();
    }

    /**
     * 跳转体检套餐详情
     * @private
     * @returns void
     */
    private onPackageDetail(item) {
        // 体检套餐
        this.$router.push({name: "package-detail", query:{id: item.targetId, productId: item.id}});
    }

    /**
     * 筛选
     * @private
     * @returns void
     */
     private onDropdownClose() {
        this.onRefresh();
     }

    /**
     * 筛选
     * @private
     * @returns void
     */
    private onReset() {
        let initMoreFilter = {
            priceRange: '',
            minPrice: '',
            maxPrice: '',
            marriageStatus: '2',
        };
        this.filters = {...this.filters, ...initMoreFilter};
    } 

    /**
     * 跳转体检套餐详情
     * @private
     * @returns void
     */
    private onMoreFilterConfirm() {
      (this.$refs.moreFilter as any).toggle();
      this.onRefresh();
    }

    /**
     * 价格区间
     * @private
     * @returns void
     */
    private onChangePrice(item: any) {
        this.filters.priceRange = item.id;
        this.filters.minPrice = item.minPrice;
        this.filters.maxPrice = item.maxPrice;
    }

    /**
     * 婚姻状况
     * @private
     * @returns void
     */
    private onChangeMarriage(item: any) {
        this.filters.marriageStatus = item.value;
    }

    /**
     * 婚姻状况
     * @private
     * @returns void
     */
    private onPriceSort() {
        if (this.priceSort === this.priceSortMap.unSort) {
            this.priceSort = this.priceSortMap.asc;
        }
        else if (this.priceSort === this.priceSortMap.asc) {
            this.priceSort = this.priceSortMap.des;
        }
        else if (this.priceSort === this.priceSortMap.des) {
            this.priceSort = this.priceSortMap.unSort;
        }
        this.onRefresh();
    }
 }
